// Incident report response schema used to dynamically render Report tab
// This mirrors the backend response fields and aligns with project rules.

export type JsonSchema = {
  type: "object";
  properties: Record<string, any>;
  required?: string[];
};

export const INCIDENT_REPORT_RESPONSE_SCHEMA: JsonSchema = {
  type: "object",
  properties: {
    title: { type: "string", title: "タイトル" },
    occurrence_date: {
      type: "array",
      items: { type: "string", format: "date-time" },
      title: "発生日時",
    },
    prerequisite: { type: "string", title: "前提条件" },
    operating_procedure: { type: "string", title: "操作手順" },
    operating_result: { type: "string", title: "動作結果" },
    expected_result: { type: "string", title: "期待結果" },
    incidence: { type: "string", title: "発生率" },
    issue_test_execution_environment: {
      type: "array",
      items: { type: "string" },
      title: "テスト実行環境",
    },
    issue_build_version: {
      type: "array",
      items: { type: "string" },
      title: "ビルドバージョン",
    },
    remarks: { type: "string", title: "備考" },
    issue_status: { type: "string", title: "課題ステータス" },
    issue_type: { type: "string", title: "課題タイプ" },
    issue_person_in_charge: { type: "string", title: "担当者" },
    issue_report_date: {
      type: "array",
      items: { type: "string", format: "date-time" },
      title: "報告日",
    },
    issue_severity: { type: "string", title: "重要度" },
    issue_priority: { type: "string", title: "優先度" },
    defect_trend: { type: "string", title: "不具合傾向" },
    specifications_applicable_section: {
      type: "string",
      title: "適用仕様箇所",
    },
    results_of_comparison_of_specifications_and_test_cases: {
      type: "string",
      title: "仕様とテストケースの照合結果",
    },
    errors: {
      type: "object",
      title: "エラー情報",
      properties: {
        error_summary: { type: "string", title: "エラー全体の概要" },
        error_details: {
          type: "array",
          title: "エラー詳細",
          items: {
            type: "object",
            properties: {
              field_name: { type: "string", title: "項目名" },
              error_reason: { type: "string", title: "エラー理由" },
            },
            required: ["field_name", "error_reason"],
          },
        },
      },
    },
  },
  required: [
    "title",
    "occurrence_date",
    "prerequisite",
    "operating_procedure",
    "operating_result",
    "expected_result",
    "incidence",
    "issue_test_execution_environment",
    "issue_build_version",
    "remarks",
    "issue_status",
    "issue_type",
    "issue_person_in_charge",
    "issue_report_date",
    "issue_severity",
    "issue_priority",
    "defect_trend",
    "specifications_applicable_section",
    "results_of_comparison_of_specifications_and_test_cases",
  ],
};

// Optional: preferred order for rendering fields in UI
export const INCIDENT_REPORT_FIELD_ORDER: string[] = [
  "title",
  "occurrence_date",
  "prerequisite",
  "operating_procedure",
  "operating_result",
  "expected_result",
  "incidence",
  "issue_test_execution_environment",
  "issue_build_version",
  "remarks",
  "issue_status",
  "issue_type",
  "issue_person_in_charge",
  "issue_report_date",
  "issue_severity",
  "issue_priority",
  "defect_trend",
  "specifications_applicable_section",
  "results_of_comparison_of_specifications_and_test_cases",
  "errors",
];
